import React from 'react';
import { Button } from './ui/Button';
import { CheckIcon, InfoIcon } from 'lucide-react';
const pricingTiers = [{
  name: 'Monthly',
  subtitle: 'Flexible option',
  price: '$25',
  period: '/month',
  savingsInfo: 'Cancel anytime',
  highlighted: false,
  features: ['2 admins', 'Unlimited teachers', 'Unlimited students', 'Unlimited subjects', 'Learning analytics', 'Advanced collaboration (roles)', 'Email & chat support', 'Dedicated success manager', '1 GB storage'],
  buttonText: 'Subscribe Monthly'
}, {
  name: 'Yearly',
  subtitle: 'Best value',
  price: '$239',
  period: '/year',
  savingsInfo: '$19.90/month (Save 21%)',
  highlighted: true,
  features: ['2 admins', 'Unlimited teachers', 'Unlimited students', 'Unlimited subjects', 'Learning analytics', 'Advanced collaboration (roles)', 'Email & chat support', 'Dedicated success manager', '1 GB storage'],
  buttonText: 'Subscribe Yearly'
}];
export function Pricing() {
  return <section id="pricing" className="py-20 bg-white" data-id="element-348">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-349">
        <div className="text-center mb-16" data-id="element-350">
          <span className="inline-block px-4 py-1 bg-[#F0F9F4] text-[#00A862] text-sm font-medium rounded-full mb-4 border border-[#00A862] shadow-sm" data-id="element-351">
            Pricing Plans
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-352">
            Simple, transparent <span className="text-[#00A862]" data-id="element-353">pricing</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8" data-id="element-354">
            Choose the plan that fits your educational community and scale as
            you grow.
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6 mt-8" data-id="element-355">
            <Button size="lg" className="min-w-[180px] shadow-md" href="https://nexioapp.eu/dashboard/register" data-id="element-356">
              Start your free trial
            </Button>
            <Button variant="outline" size="lg" className="min-w-[180px]" href="https://calendar.app.google/6fKsGXEmBQzjPvnc9" data-id="element-357">
              Schedule a Demo
            </Button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mt-12" data-id="element-358">
          {pricingTiers.map((tier, index) => {
          const isHighlighted = tier.highlighted;
          return <div key={index} className={`rounded-xl overflow-hidden border-2 transition-all duration-300 hover:shadow-lg ${isHighlighted ? 'border-[#00A862] shadow-lg scale-105 bg-gradient-to-b from-green-50 to-white' : 'border-[#00A862] shadow hover:border-[#00A862] bg-white'}`} data-id="element-359">
                {isHighlighted && <div className="bg-[#00A862] text-white text-center py-2 text-sm font-medium shadow-md" data-id="element-360">
                    Best Value
                  </div>}
                <div className="p-6" data-id="element-361">
                  <h3 className={`text-xl font-bold ${isHighlighted ? 'text-[#00A862]' : 'text-gray-900'} mb-1`} data-id="element-362">
                    {tier.name}
                  </h3>
                  <p className="text-gray-600 mb-4 text-sm" data-id="element-363">{tier.subtitle}</p>
                  <div className="mb-2 bg-gray-50 p-4 rounded-lg shadow-inner border border-gray-100" data-id="element-364">
                    <span className={`text-4xl font-bold ${isHighlighted ? 'text-[#00A862]' : 'text-gray-900'}`} data-id="element-365">
                      {tier.price}
                    </span>
                    <span className="text-gray-600" data-id="element-366">{tier.period}</span>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 rounded-lg mb-6 shadow-sm" data-id="element-367">
                    <p className={`text-sm font-medium ${isHighlighted ? 'text-[#00A862]' : 'text-gray-700'}`} data-id="element-368">
                      {tier.savingsInfo}
                    </p>
                  </div>
                  <ul className="space-y-3 mb-8 bg-gray-50 p-4 rounded-lg shadow-sm" data-id="element-369">
                    {tier.features.map((feature, featureIndex) => <li key={featureIndex} className="flex items-start" data-id="element-370">
                        <CheckIcon className={`h-5 w-5 ${isHighlighted ? 'text-[#00A862]' : 'text-[#00A862]'} mr-2 flex-shrink-0`} data-id="element-371" />
                        <span className="text-gray-700 text-sm" data-id="element-372">{feature}</span>
                      </li>)}
                  </ul>
                  <div className="space-y-3" data-id="element-373">
                    <a href="https://nexioapp.eu/dashboard/register" className={`w-full inline-flex items-center justify-center font-medium rounded-lg px-4 py-2 transition-colors ${isHighlighted ? 'bg-[#00A862] text-white hover:bg-[#008F54]' : 'border border-[#00A862] text-[#00A862] hover:bg-[#F0F9F4]'}`} data-id="element-374">
                      {tier.buttonText}
                    </a>
                    <Button variant="ghost" className="w-full" data-id="element-375">
                      Learn More
                    </Button>
                  </div>
                </div>
              </div>;
        })}
        </div>
        <div className="mt-10 bg-white p-6 rounded-lg border border-gray-200 shadow-md max-w-4xl mx-auto" data-id="element-376">
          <div className="flex items-start" data-id="element-377">
            <InfoIcon className="h-6 w-6 text-[#00A862] mr-3 flex-shrink-0 mt-0.5" data-id="element-378" />
            <div data-id="element-379">
              <h4 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-380">
                Need more storage?
              </h4>
              <p className="text-gray-600 mb-2" data-id="element-381">
                Additional storage available for $10 per 10GB.
              </p>
              <p className="text-gray-600 text-sm" data-id="element-382">
                Contact our team after subscribing to add extra storage to your
                plan.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-10 text-center bg-gray-50 py-6 rounded-lg max-w-3xl mx-auto" data-id="element-383">
          <p className="text-gray-600 font-medium" data-id="element-384">
            All plans include a 14-day free trial. No credit card required.
          </p>
        </div>
      </div>
    </section>;
}